import clsx from 'clsx'
import {orderBy} from 'lodash'
import React, {useContext} from 'react'
import {Link} from 'react-router-dom'
import {makeStyles} from 'external/material'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import TableBody from '@mui/material/TableBody'

import moment from 'helpers/moment'

import {TeacherContext} from 'teacher/context'

const useStyles = makeStyles(studentGradesSummaryBodyStyles)

export default function StudentGradesSummaryBody() {

  const classes = useStyles()
  const context = useContext(TeacherContext)

  const {translate, groupId, studentId, gradingCategories} = context

  const grades = context.rollbookContextGrades.items.filter(g => g.student == studentId)
  const gradeColumns = context.rollbookContextGradeColumns.items.reduce((columns, column) => {
    columns[column.id] = column
    return columns
  }, {})
  const periods = context.rollbookContextPeriods.items.map(period => ({...period,
    grades: grades
      .filter(g => moment(g.start).isSameOrAfter(period.start) && moment(g.start).isSameOrBefore(period.finish))
      .reduce((acc, grade) => {
        const type = acc[grade.type] || (acc[grade.type] = {})
        const selected = grade.properties && grade.properties.selected
        const original = !grade.makeupFor
        const id = grade.makeupFor || grade.assignment
        const gradeColumn = gradeColumns[id] || {properties: {ignore: false}}
        const assignment = (context.rollbookContextStudentAssignmentProperties[studentId] || {})[id] || {properties: {ignore: false}}
        const ignore = gradeColumn.properties.ignore || assignment.properties.ignore
        if (ignore || (!original && !selected)) return acc
        if (!type[id] || (type[id] && type[id].properties && !type[id].properties.selected))
          type[id] = grade
        return acc
      }, {})
  }))
  const columns = orderBy(periods, [p => moment(p.start).valueOf()])
  const quizRows = gradingCategories.filter(t => t.name != 'practice2').map(t => {
    const gradeColumns = columns.map(c => {
      const typeGrades = Object.values(c.grades[t.id] || {})
      const points = typeGrades.reduce((points, grade) => points + grade.points, 0)
      const total = typeGrades.reduce((total, grade) => total + grade.total, 0)
      return {points, total}
    })
    const summaryColumn = gradeColumns.reduce((acc, column) => ({total: acc.total + column.total, points: acc.points + column.points}), {total: 0, points: 0})
    return [translate(`${t.name}-label`), summaryColumn].concat(gradeColumns)
  })

  const globalRow = quizRows.reduce((acc, row) => {
    const [_, summaryColumn, ...gradeColumns] = row
    const [name, globalColumn, ...globalColumns] = acc
    return [
      name,
      {total: globalColumn.total + summaryColumn.total, points: globalColumn.points + summaryColumn.points},
      ...gradeColumns.map((c,i) => {
        const g = globalColumns[i] || {total: 0, points: 0}
        return {total: c.total + g.total, points: c.points + g.points}
      })
    ]
  }, [translate('global-grade'), {total: 0, points: 0}])

  const rows = [globalRow].concat(quizRows)

  const summary = ({total, points}) => total == 0 ? 0 : `${(points / total * 100).toFixed(2)}%`

  return (
    <TableBody>
      {rows.map((row, index) => {
        const [nameColumn, summaryColumn, ...gradeColumns] = row
        return (
         <TableRow key={index} className={classes.row}>  
           <TableCell align="left" className={classes.cell}>{nameColumn}</TableCell>
           <TableCell align="center" className={clsx(classes.cell, 'summary')}>{summary(summaryColumn)}</TableCell>
           {gradeColumns.map((column, index) => (
             <TableCell key={index} align="center" className={clsx(classes.cell)}>{summary(column)}</TableCell>
           ))}
           <TableCell className={classes.filler} style={{top:92}} align="right" />            
         </TableRow>
        )}
      )}
    </TableBody>
  )
}

function studentGradesSummaryBodyStyles() {
  return {
    cell: {
      padding: 0,
      color: '#4f576e',
      fontWeight: 500,
      borderLeft: 'solid 1px #d8dbe0',
      borderRight: 'solid 1px #d8dbe0',
      '&:first-child': {
        borderLeft: 0,
        paddingLeft: 10
      },
      '&.summary': {
        backgroundColor:'#f5fff6'
      }
    },
  }
}
